module.exports = __webpack_public_path__ + "dbaf40438836897105274aa2c63415a8.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Header/images/logo.png
 ** module id = 1629
 ** module chunks = 0
 **/